export const Courses = () => {
  const fileName = "ОбразовательнаяПрограммаКурсов2025.pdf";
  const fileUrl = `/documents/${encodeURI(fileName)}`;

  const openFile = () => {
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      openFile();
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-200 p-4">
      <div
        role="button"
        tabIndex={0}
        aria-label="Открыть программу курса (PDF)"
        onClick={openFile}
        onKeyDown={handleKeyDown}
        className="group max-w-3xl w-full cursor-pointer outline-none"
      >
        <div className="mx-auto bg-white/80 backdrop-blur rounded-2xl shadow-xl ring-1 ring-black/5 p-8 transition-shadow duration-200 hover:shadow-2xl focus-visible:ring-2 focus-visible:ring-indigo-400">
          <div className="flex items-start gap-6">
            <div className="shrink-0 rounded-2xl ring-1 ring-slate-200 p-4 group-hover:ring-indigo-200 transition">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                className="w-14 h-14 text-indigo-600"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M7.5 3.75h6.75L19.5 9v11.25a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V4.5a.75.75 0 0 1 .75-.75z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M14.25 3.75V9h5.25"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 13.5h6M9 16.5h6M9 19.5h6"
                />
              </svg>
            </div>

            <div className="space-y-3">
              <h1 className="text-xl md:text-2xl font-semibold text-slate-900 leading-relaxed">
                Проектирование организационной деятельности посредством интеллектуальной игры
                в воспитательно-образовательном процессе дошкольных организаций
              </h1>

              <p className="text-sm text-slate-500">
                Загружено 11-го июля 2025 г.
              </p>

              <div className="pt-2">
                <span className="inline-flex items-center gap-2 text-sm md:text-base font-medium text-indigo-700 underline decoration-dotted group-hover:decoration-solid">
                  Открыть программу курса (PDF)
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    className="w-4 h-4"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13.5 6H18m0 0v4.5M18 6l-6.75 6.75M6 18h12"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>

          <div className="mt-6 pt-6 border-t border-slate-200">
            <p className="text-sm md:text-base text-slate-700">
              Направлять предложения на почту:{" "}
              <a
                href="mailto:info.edumax.kz@gmail.com"
                className="font-medium underline hover:no-underline text-indigo-700"
                onClick={(e) => e.stopPropagation()}
              >
                info.edumax.kz@gmail.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Courses;
